export default __webpack_public_path__ + "static/media/gbp.47725f04.svg";